import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { AGENT_KEY_BASE_PATH } from '../../../../features/agent-auth/agent-key-routing';

export const Route = createFileRoute('/_app/developer/agent-key/_agent-key')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'agent-key',
        label: 'Developers',
        to: AGENT_KEY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
